import { createContext, Dispatch, ReactNode, useReducer } from 'react';

import { POLICIES } from './data/policies';

export type IContext = {
	[policy in (typeof POLICIES)[number]['id']]: boolean;
};

const initialState = POLICIES.reduce(
	(acc, policy) => ({ ...acc, [policy.id]: true }),
	{},
) as IContext;

export const MapContext = createContext<{
	context: IContext;
	updateContext: Dispatch<any>;
}>({ context: initialState, updateContext: () => null });

const actionIds = ['TOGGLE_ALL_OFF', 'TOGGLE_ALL_ON', 'TOGGLE_PLAN'] as const;

const mapReducer = (
	state: IContext,
	action: { id: (typeof actionIds)[number]; plan: keyof IContext },
) => {
	switch (action.id) {
		case 'TOGGLE_ALL_OFF':
			return toggleAll(state, false);
		case 'TOGGLE_ALL_ON':
			return toggleAll(state, true);
		case 'TOGGLE_PLAN':
			return { ...state, [action.plan]: !state[action.plan] };
	}
};

function toggleAll(state: IContext, toggle: boolean) {
	const changed: Partial<IContext> = POLICIES.reduce(
		(acc, policy) => ({ ...acc, [policy.id]: toggle }),
		{},
	);
	return { ...state, ...changed };
}

interface Props {
	children: ReactNode;
}

export const StateProvider = ({ children }: Props) => {
	const [context, updateContext] = useReducer(mapReducer, initialState);
	return (
		<MapContext.Provider value={{ context, updateContext }}>
			{children}
		</MapContext.Provider>
	);
};
